import XLSX from "sheetjs-style";

export const exportFunction = (data, heading) => {
    if (data && data.length > 0) {
        const header = Object.keys(data[0]);
        const sheet = XLSX.utils.json_to_sheet(data, { header });

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, sheet, "Sheet1");

        XLSX.writeFile(wb, `${heading}.xlsx`);
    } else {
        alert("No data to export");
    }
};


export const displayValue = (value, digits = 2) => {
    if (value == null || isNaN(value)) {
        return 0;
    }

    if (value === 0) {
        return 0;
    }

    if (Number.isInteger(value)) {
        return Math.round(value);
    }

    return parseFloat(value.toFixed(digits));
};